import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {TokenWithInvitation} from "../entities/token-with-invitation";

export interface TokenRevokeAccessDialogProps {
    open: boolean;
    onClose: (token?: TokenWithInvitation) => void;
    token?: TokenWithInvitation;
}

export const TokenRevokeAccessDialog = (props: TokenRevokeAccessDialogProps) => {
    return props.token ? <Dialog
        open={props.open}
        onClose={() => props.onClose()}
    >
        <DialogTitle>Revocation confirmation</DialogTitle>
        <DialogContent dividers>
            <Typography>
                Are you sure you want to revoke access to the academy
                for {props.token.inviteeFirstname} {props.token.inviteeLastname} ?
            </Typography>
            <Typography>
                The revocation will take place immediately and {props.token.inviteeFirstname} will loose access to the
                stream on the academy
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button autoFocus onClick={() => props.onClose()} color="error" tabIndex={0}>
                Cancel
            </Button>
            <Button onClick={() => props.onClose(props.token)} color="success" tabIndex={1}>Ok</Button>
        </DialogActions>
    </Dialog> : <></>
}